import Questionnaire from "../sections/Questionnaire";

const icons = [
  {
    title: "Haus",
    externalLink: "/hauswasserwerk/#intro",
    imgUrl: "/content/uploads/2018/08/haus.png"
  },
  {
    title: "Garten",
    externalLink: "/hauswasserautomat/#intro",
    imgUrl: "/content/uploads/2018/08/garten.png"
  },
  {
    title: "Haus & Garten",
    externalLink: "/hauswasserwerk/#intro",
    imgUrl: "/content/uploads/2018/08/haus-garten.png"
  },
  {
    title: "Austausch",
    externalLink: "/kreiselpumpe/#intro",
    imgUrl: "/content/uploads/2018/08/austausch.png"
  }
]

export function Less9Meter() {
  return (
    <Questionnaire question={"Wofür soll die Pumpe verwendet werden?"} icons={icons} />
  );
}